const Dilmun = require('../../assets/images/Dilmun-HomePage.png');
const OOP = require('../../assets/images/OOP-Movie-Project.png');
const Shopify = require('../../assets/images/shopify-challenge.png');

export const projects = [
  {
    id: '1',
    name: 'Dilmun',
    description:
      'Capstone team project built at Re:Coded bootcamp. Dilmun allows people to sell, buy and even donate products with a click of a button.',
    image: Dilmun,
    codeUrl: 'https://github.com/ReCoded-Org/capstone-IQLBPS-Dilmun',
    siteUrl: 'https://capstone-dilmun.netlify.app/',
  },
  {
    id: '2',
    name: 'OOP Movie Project',
    description:
      " A project to practice object-oriented programming in JavaScript. Utilizing TMDB API to get movies' and actors' details.",
    image: OOP,
    codeUrl: 'https://github.com/sarahaboudalal/OOP-Movie-Project',
    siteUrl: 'https://sarahaboudalal.github.io/OOP-Movie-Project/',
  },
  {
    id: '3',
    name: 'Shopify Challenge',
    description:
      'Built using React.js and styled with Tailwind CSS, this website allows you to search for your favorite movies, nominate the top 5, and let the website choose a winner movie for you.',
    image: Shopify,
    codeUrl: 'https://github.com/sarahaboudalal/Shopify-Challenge',
    siteUrl: 'https://shopify-react-challenge.netlify.app',
  },
];
